export const $ = (selector: string): HTMLElement | null => document.querySelector(selector);
export const $id = (id: string): HTMLElement | null => document.getElementById(id);


export const onClick = (element: HTMLElement | null, handler: (event: MouseEvent) => void): void => {
  element?.addEventListener('click', handler);
};
export const onInput = (element: HTMLElement | null, handler: (event: Event) => void): void => {
  element?.addEventListener('input', handler);
};
export const onEscPress = (handler: (event: KeyboardEvent) => void): void => {
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      handler(event);
    }
  });
};
export const onEnterPress = (element: HTMLElement | null, handler: (event: KeyboardEvent) => void): void => {
  element?.addEventListener('keypress', (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      handler(event);
    }
  });
};



// Simple seeded pseudorandom number generator (Mulberry32)
function seededRandom(seed: number): () => number {
  return function() {
    seed |= 0;
    seed = seed + 0x6D2B79F5 | 0;
    let t = Math.imul(seed ^ seed >>> 15, 1 | seed);
    t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t;
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
  };
}

// Fisher-Yates shuffle using a seeded random number generator
function shuffleWithSeed(array: number[], seed: number): number[] {
  const result = [...array];
  const rng = seededRandom(seed);
  
  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    [result[i], result[j]] = [result[j], result[i]];
  }
  
  return result;
}


/**
 * Returns a number from 0-(maxNumber-1) based on the date, with a different
 * deterministic random order every maxNumber days.
 * 
 * @param date - The date to calculate for
 * @param epochDate - The reference date to start counting from (default: Jan 1, 2000)
 * @returns A number from 0 to (maxNumber-1) (inclusive)
 */
export function getDayNumber(date: Date, maxNumber: number): number {
  // Saint Jean-Baptiste Day (June 24) 1834, in Québec, Canada timezone
  const epochDate: Date = new Date('1834-06-24T00:00:00-04:00');

  // Calculate days since epoch
  const msPerDay = 1000 * 60 * 60 * 24;
  const daysSinceEpoch = Math.floor(
    (date.getTime() - epochDate.getTime()) / msPerDay
  );

  // Calculate which maxNumber-day loop we're in
  const loopIndex = Math.floor(daysSinceEpoch / maxNumber);

  // Calculate which day within the current loop (0-(maxNumber-1))
  const dayInLoop = daysSinceEpoch % maxNumber;

  // Generate the shuffled order for this loop
  const numbers = Array.from({ length: maxNumber }, (_, i) => i);
  const shuffled = shuffleWithSeed(numbers, loopIndex);
  
  // Return the number for this specific day
  return shuffled[dayInLoop];
}